import { css, stack } from '@bts-web/utils-style-engine';

export const scrollableBodyStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  overflow: 'auto',
});

export const bottomSectionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  gap: 'small',
  p: 'medium',
});

export const inputSectionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  p: 'medium',
});

export const assetRowStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'extra_small_2',
  pb: 'extra_small_2',
});

export const assetIconStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '24px',
  height: '24px',
  color: 'neutrals.text_primary_inverted',
  borderRadius: '50%',
  backgroundColor: 'neutrals.fill_primary',
});

export const assetNameStyles = css({
  fontSize: 'title.medium_medium',
  fontWeight: 'title.medium_medium',
  letterSpacing: 'title.medium_medium',
  lineHeight: 'title.medium_medium',
  color: 'neutrals.text_primary',
});

export const chipsRowStyles = css({
  display: 'flex',
  overflow: 'auto',
  gap: 'extra_small_2',
  overflowX: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
});

export const chipStyles = css({
  flexShrink: 0,
  cursor: 'pointer',
  px: 'medium',
  py: 'extra_small_2',
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  letterSpacing: 'caption.small',
  lineHeight: 'caption.small',
  color: 'neutrals.text_primary',
  border: '1px solid',
  borderColor: 'neutrals.stroke_secondary',
  borderRadius: 'extraSmallBottomRight',
  background: 'screen_background.primary',
});

export const helperRowStyles = css({
  pt: 'small',
  pb: 'small',
});

export const helperTextStyles = css({
  height: 'small',
  fontSize: 'caption.small_light',
  fontWeight: 'caption.small_light',
  letterSpacing: 'caption.small_light',
  lineHeight: 'caption.small_light',
  color: 'neutrals.text_primary',
});

export const availableIconStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '40px',
  height: '40px',
  color: 'neutrals.text_primary_inverted',
  borderRadius: '50%',
  backgroundColor: 'neutrals.fill_primary',
});

export const availableTrailingStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: 'extra_small_3',
});

export const borderedSectionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'medium',
  mx: 'medium',
  py: 'medium',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'neutrals.divider',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'neutrals.divider',
});

export const disclaimerSectionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_2',
  mx: 'medium',
  borderRadius: '8px',
  border: '2px solid',
  borderColor: 'warning.stroke_primary',
  padding: 'small',
  fontSize: 'body.medium',
});

export const disclaimerTitleStyles = css({
  color: 'warning.stroke_primary',
});

export const availableRowStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'medium',
});

export const availableAssetInfoStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: 'extra_small_3',
  minWidth: 0,
});

export const availableLabelStyles = css({
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  letterSpacing: 'caption.small',
  lineHeight: 'caption.small',
  color: 'neutrals.text_secondary',
});

export const availableNameStyles = css({
  fontSize: 'label.medium_medium',
  fontWeight: 'label.medium_medium',
  letterSpacing: 'label.medium_medium',
  lineHeight: 'label.medium_medium',
  color: 'neutrals.text_primary',
});

export const totalsStyles = stack({
  direction: 'column',
  gap: 'extra_small_2',
});

export const totalRowStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const totalLabelStyles = css({
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  letterSpacing: 'caption.small',
  lineHeight: 'caption.small',
  color: 'neutrals.text_secondary',
});

export const totalValueStyles = css({
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  letterSpacing: 'caption.small',
  lineHeight: 'caption.small',
  color: 'neutrals.text_secondary',
});

export const grandTotalLabelStyles = css({
  fontSize: 'title.medium',
  fontWeight: 'title.medium',
  letterSpacing: 'title.medium',
  lineHeight: 'title.medium',
  color: 'neutrals.text_primary',
});

export const grandTotalValueStyles = css({
  fontSize: 'title.medium',
  fontWeight: 'title.medium',
  letterSpacing: 'title.medium',
  lineHeight: 'title.medium',
  color: 'neutrals.text_primary',
});
